import { I18n } from '@calendly/i18n';
import { Badge } from '@calendly/ui/components/badge';
import { TitleText } from '@calendly/ui/components/typography';
import { colorTextSecondary, colorTextStandard } from '@calendly/ui/theme';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { dateNotationSelector } from 'selectors/current_user';
import { userDateFormatCheckYear } from 'services/time_format';
import { useCurrentTime } from 'shared/contexts';
const dateBadgeContainerCss = "dd8c2em";
const todayBadgeCss = "txgjj1m";
const DATE_FORMATS = {
  day: 'ddd',
  withoutYear: 'date_small',
  withYear: 'date_small_with_year'
} as const;
interface DateBadgeProps {
  date: string;
}

/**
 * Displays a date label for a meeting group. Shows a "Today" badge for the
 * current day, or the abbreviated day name for other dates. The date string
 * automatically includes the year when the date is not in the current year.
 *
 * @param date - A date string parseable by moment (e.g. 'YYYY-MM-DD')
 */
export const DateBadge = ({
  date
}: DateBadgeProps) => {
  const currentTime = useCurrentTime();
  const dateFormat = useSelector(dateNotationSelector);
  const dateMmt = moment(date);
  const isToday = dateMmt.isSame(currentTime, 'day');
  const dayName = dateMmt.format(DATE_FORMATS.day);
  const dateStr = userDateFormatCheckYear(dateMmt, dateFormat, DATE_FORMATS.withoutYear, DATE_FORMATS.withYear);
  return <div className={dateBadgeContainerCss}>
      {!isToday && <TitleText level={4} size="large" color={colorTextStandard}>{dayName}</TitleText>}
      <TitleText level={4} size="large" color={colorTextSecondary}>{dateStr}</TitleText>
      {isToday && <span className={todayBadgeCss}><Badge type="info">{I18n.t('publisher.dashboard.filters.today')}</Badge></span>}
    </div>;
};

require("./DateBadge.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./DateBadge.tsx");